<!--
/**
 * DjFreezeTab.vue - 自选套餐冻结 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的自选套餐冻结管理页面，
 * 用于对号码的自选套餐进行冻结和解冻操作。冻结后号码无法使用自选套餐，
 * 解冻后恢复使用。支持明细记录和批量记录两种视图。
 *
 * 【主要功能】
 * 1. 冻结记录查询 - 支持明细记录和批量记录两种视图切换
 * 2. 添加冻结/解冻 - 输入号码批量执行冻结或解冻操作
 * 3. 批量记录导出 - 导出批量操作的结果数据
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 视图类型切换（明细记录/批量记录） -->
      <el-select size="small" style="width: 120px" v-model="query11.type" filterable placeholder="状态"
                 class="handle-select mr10" @change="getfrozenRecord">
        <el-option v-for="item in freezeTypeList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- UID输入框 -->
      <el-input size="small" v-model="query11.uid" clearable maxlength="12" placeholder="请输入uid"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query11.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 状态筛选（仅明细记录视图显示） -->
      <el-select size="small" style="width: 100px" v-model="query11.status" filterable clearable
                 placeholder="状态" class="handle-select mr10" v-if="query11.type==1">
        <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
                 @click="getfrozenRecord">搜索
      </el-button>
      <!-- 添加冻结按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
                 @click="handleAdd11">添加冻结
      </el-button>
    </div>

    <!-- ========== 明细记录视图（type==1） ========== -->
    <!-- 显示每一条冻结/解冻操作的详细信息 -->
    <div v-if="query11.type==1">
      <el-table :data="tableData11" border class="table" ref="multipleTable" max-height="600"
                header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                v-loading="loading">
        <!-- UID -->
        <el-table-column prop="uid" label="UID" align="center"></el-table-column>
        <!-- 手机号 -->
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <!-- 类型（冻结=红色，解冻=绿色） -->
        <el-table-column prop="type" label="类型" align="center">
          <template #default="scope">
            <span v-if="scope.row.type == '冻结'" class="status_color2 bgred">{{ scope.row.type }}</span>
            <span v-if="scope.row.type == '解冻'" class="status_color2 bggreen">{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <!-- 状态（失败=红色，成功=默认） -->
        <el-table-column prop="status" label="状态" align="center">
          <template #default="scope">
            <span style="color: #f56c6c;" v-if="scope.row.status == false">失败</span>
            <span v-else>成功</span>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <!-- 失败原因 -->
        <el-table-column prop="errMsg" label="失败原因" align="center"></el-table-column>
        <!-- 记录时间 -->
        <el-table-column prop="createdAt" label="记录时间" align="center" width="175"></el-table-column>
      </el-table>
    </div>

    <!-- ========== 批量记录视图（type==2） ========== -->
    <!-- 显示按批次汇总的操作统计（总数/成功/失败） -->
    <div v-else>
      <el-table :data="tableData11" border class="table" ref="multipleTable" max-height="600"
                header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
                v-loading="loading">
        <!-- UID（批次号） -->
        <el-table-column prop="uid" label="UID" align="center"></el-table-column>
        <!-- 总数 -->
        <el-table-column prop="total" label="总数" align="center"></el-table-column>
        <!-- 成功数 -->
        <el-table-column prop="success" label="成功" align="center"></el-table-column>
        <!-- 失败数 -->
        <el-table-column prop="fail" label="失败" align="center"></el-table-column>
        <!-- 时间 -->
        <el-table-column prop="time" label="时间" align="center"></el-table-column>
        <!-- 操作列 - 导出该批次数据 -->
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button size="small" type="text" icon="el-icon-upload2"
                       @click="handleExport(scope.row)">导出
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query11.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query11.pageSize" :total="pageTotal11" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 添加冻结弹窗 ========== -->
    <el-dialog title="添加冻结" v-model="addVisible11" width="520px" @close="closeDialog11">
      <el-form label-width="120px" :model="addForm11" ref="addForm11">
        <!-- 类型选择：冻结 或 解冻 -->
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm11.type">
            <el-radio label="1">冻结</el-radio>
            <el-radio label="0">解冻</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手机号码（一行一个，最多500个） -->
        <el-form-item label="手机号码" prop="phones">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm11.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <!-- 冻结/解冻原因 -->
        <el-form-item label="原因" prop="remark">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm11.remark" auto-complete="off"
                    placeholder="请输入冻结/解冻原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog11">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getFrozen">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自选套餐冻结 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - frozen：执行冻结/解冻操作
 * - frozenRecord：查询冻结记录
 * - frozenRecordDownload：下载批量冻结记录
 */
import {
  frozen,
  frozenRecord,
  frozenRecordDownload
} from '../../../api/dijia.js';

export default {
  name: 'DjFreezeTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   */
  props: {
    theme: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      query11: {                // 查询参数
        userId: localStorage.getItem('user'),
        status: '',             // 状态筛选
        phone: '',              // 手机号
        type: 1,                // 视图类型（1=明细记录，2=批量记录）
        uid: '',                // UID
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
      },
      freezeTypeList: [         // 视图类型选项
        { value: 1, label: '明细记录' },
        { value: 2, label: '批量记录' }
      ],
      succeedList2: [           // 状态筛选选项
        { value: 0, label: '全部' },
        { value: 1, label: '成功' },
        { value: -1, label: '失败' }
      ],
      tableData11: [],          // 记录列表
      pageTotal11: 0,           // 总条数

      // ========== 添加弹窗相关 ==========
      addVisible11: false,      // 弹窗是否显示
      addForm11: {              // 添加表单
        phones: '',             // 手机号（一行一个）
        userId: localStorage.getItem('user'),
        remark: '',             // 冻结/解冻原因
        type: '1',              // 类型（1=冻结，0=解冻）
      },
    };
  },

  /**
   * 组件创建时查询冻结记录
   */
  created() {
    this.getfrozenRecord();
  },

  methods: {
    /**
     * getfrozenRecord - 查询冻结记录列表
     */
    getfrozenRecord() {
      this.loading = true;
      frozenRecord(this.query11).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData11 = res.data.list;
          this.pageTotal11 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handleExport - 导出批量记录数据
     * @param {Object} row - 批量记录行数据
     */
    handleExport(row) {
      let data = { uid: row.uid };
      frozenRecordDownload(data).then(res => {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        let fileName = '迪加自选套餐冻结.xlsx';
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      });
    },

    /**
     * handleAdd11 - 打开添加冻结弹窗
     */
    handleAdd11() {
      this.addVisible11 = true;
    },

    /**
     * getFrozen - 提交冻结/解冻操作
     */
    getFrozen() {
      frozen(this.addForm11).then(res => {
        if (res?.code === 200) {
          this.addVisible11 = false;
          this.$message.success(res.data);
          setTimeout(() => {
            this.getfrozenRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * closeDialog11 - 关闭弹窗并重置表单
     */
    closeDialog11() {
      this.addVisible11 = false;
      this.addForm11.phones = '';
      this.addForm11.remark = '';
      this.addForm11.type = '1';
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query11.pageIndex = val;
      this.getfrozenRecord();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query11.pageSize = val;
      this.query11.pageIndex = 1;
      this.getfrozenRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
